<template>
  <div id="home">
    <section id="section-banner" class="container">
      <div id="logo-container" class="d-flex justify-content-center d-lg-block">
        <h1>
          <img
            id="midia-festival-logo"
            src="@/assets/img/2022/midia-festival-logo.png"
            alt="Mídia Festival"
          />
        </h1>
      </div>
      <div id="txt-banner-subtitle">
        Um prêmio feito<br />
        para todo mundo.<br />
        mas só as<br />
        <img
          id="melhores-ideias"
          src="@/assets/img/2022/melhores-ideias.png"
          alt="melhores ideias"
        /><br />
        ganham.<br />
      </div>
      <img
        id="img-banner"
        src="@/assets/img/2022/first-banner.png"
        alt="Banner"
      />
    </section>
    <div id="rect-grey-ground" />
    <section id="section-festival" class="container">
      <h1>
        <img
          id="img-o-festival"
          src="@/assets/img/2022/o-festival-title.png"
          alt="O Festival"
        />
      </h1>
      <div id="text-festival">
        O Mídia Festival tem como objetivo principal premiar a criatividade e a
        qualidade dos trabalhos produzidos para os diversos meios de
        comunicação, criados por agências de propaganda, agências digitais e
        fornecedores. Além disso, busca incentivar os profissionais da área,
        visando o fomento da indústria da propaganda no interior.
      </div>
    </section>

    <section id="section-regulamento">
      <div class="container">
        <h1 id="regulamento-title-container" class="font-cleopatra">
          Regulamento
        </h1>
        <div class="regulamento-btn-container">
          <a
            target="_blank"
            href="/regulamentos/2022/regulamento-pecas-publicitarias-2022.pdf"
            class="btn-round"
          >
            <span>Peça Publicitária</span>
          </a>
          <a
            target="_blank"
            href="/regulamentos/2022/regulamento-fornecedores-2022.pdf"
            class="btn-round"
          >
            <span>Fornecedor</span>
          </a>
          <a
            target="_blank"
            href="/regulamentos/2022/regulamento-estudantes-2022.pdf"
            class="btn-round"
          >
            <span>Estudante</span>
          </a>
        </div>
        <div class="regulamento-btn-container">
          <router-link to="/login" class="btn-round inscreva-se">
            <span>Inscreva-se</span>
          </router-link>
        </div>
      </div>
    </section>

    <section id="section-datas">
      <img
        id="img-data-banner"
        src="@/assets/img/2022/datas-banner2.png"
        alt="Banner"
      />
      <div id="datas-container" class="container">
        <div id="datas-position">
          <h1>
            <img src="@/assets/img/2022/datas-title.png" alt="Datas" />
          </h1>
          <div class="data-single-container">
            <div class="txt-data-title">02/09</div>
            <div class="txt-data-subtitle">Início das inscrições</div>
          </div>
          <div class="data-single-container">
            <div class="txt-data-title">27/10</div>
            <div class="txt-data-subtitle">Término das inscrições</div>
          </div>
          <div class="data-single-container">
            <div class="txt-data-title">14/11</div>
            <div class="txt-data-subtitle">Shortlist</div>
          </div>
          <div class="data-single-container">
            <div class="txt-data-title">17/11</div>
            <div class="txt-data-subtitle">Cerimônia de premiação</div>
          </div>
        </div>
      </div>
    </section>
    <section id="section-patrocinadores">
      <div id="patrocinadores-wrapper" class="container-fluid bg-white py-6">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="text-uppercase font-brandon-bold big">Patrocinadores</h2>
          </div>
          <b-row class="mt-2 justify-content-between">
            <b-col cols="5">
              <h3
                class="
                  font-brandon-bold
                  text-uppercase
                  mb-3
                  text-center text-xl-left
                "
              >
                Mantenedores Ouro:
              </h3>
              <div
                class="
                  mantenedores-ouro-wrapper
                  w-100
                  d-flex
                  flex-wrap
                  justify-content-center justify-content-xl-start
                "
              >
                <img
                  src="@/assets/img/patrocinadores/mantenedores-ouro/band-mais.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-ouro/tv-thati-record.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-ouro/eptv-g1.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-ouro/vtv-sbt-2022.png"
                />
              </div>
            </b-col>
            <b-col cols="6">
              <h3
                class="
                  font-brandon-bold
                  text-uppercase
                  mb-3
                  mt-sm-4 mt-lg-0
                  text-center text-xl-left
                "
              >
                Mantenedores Prata:
              </h3>
              <div
                class="
                  mantenedores-prata-wrapper
                  w-100
                  d-flex
                  flex-wrap
                  justify-content-center justify-content-xl-start
                "
              >
                <img
                  src="@/assets/img/patrocinadores/mantenedores-prata/clear-channel.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-prata/eletromidia.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-prata/jcdecaux.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-prata/jovem-pan-campinas.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-prata/parque-dom-pedro.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-prata/rede-familia-2022.png"
                />
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-5">
            <b-col lg="12">
              <h3 class="font-brandon-bold big text-uppercase mb-3 text-center">
                Apoio:
              </h3>
              <div
                class="
                  apoio-wrapper
                  primary-line
                  d-flex
                  justify-content-around
                  flex-wrap
                  align-items-center
                  mb-4
                "
              >
                <img
                  src="@/assets/img/patrocinadores/apoio/agencia-era.png"
                  style="width: 110px"
                />
                <img src="@/assets/img/patrocinadores/apoio/band-multi.png" />
                <img
                  src="@/assets/img/patrocinadores/apoio/barini-de-santis-advogados.png"
                />
                <img src="@/assets/img/patrocinadores/apoio/benhur.png" />
                <img
                  src="@/assets/img/patrocinadores/apoio/cavena-studio.png"
                  style="width: 125px"
                />
                <img
                  src="@/assets/img/patrocinadores/apoio/diario-campineiro.png"
                />
                <img
                  src="@/assets/img/patrocinadores/apoio/dinamize.png"
                  style="width: 110px"
                />
                <img
                  src="@/assets/img/patrocinadores/apoio/euromidia-comunicacao.png"
                />
                <img
                  src="@/assets/img/patrocinadores/apoio/kremer-express.png"
                />
                <img src="@/assets/img/patrocinadores/apoio/mjr-eventos.png" />
                <img src="@/assets/img/patrocinadores/apoio/pamplace.png" />
                <img
                  src="@/assets/img/patrocinadores/apoio/band-fm.png"
                  style="width: 100px"
                />
                <img
                  src="@/assets/img/patrocinadores/apoio/radio-bandeirantes-2022.png"
                  style="width: 60px"
                />
                <img
                  src="@/assets/img/patrocinadores/apoio/radio-cbn-campinas.png"
                />
                <img
                  src="@/assets/img/patrocinadores/apoio/radio-central.png"
                />
                <img src="@/assets/img/patrocinadores/apoio/radio-cidade.png" />
                <img
                  src="@/assets/img/patrocinadores/apoio/cidade-gospel.png"
                />
                <img src="@/assets/img/patrocinadores/apoio/educadora.png" />
                <img src="@/assets/img/patrocinadores/apoio/radio-laser.png" />
                <img src="@/assets/img/patrocinadores/apoio/nativa.png" />
                <img src="@/assets/img/patrocinadores/apoio/nova-brasil.png" />
                <img
                  src="@/assets/img/patrocinadores/apoio/royal-midia-2022.png"
                />
                <img
                  src="@/assets/img/patrocinadores/apoio/vitoria-hotel-concept-campinas.png"
                />
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-5">
            <b-col lg="12">
              <h3 class="font-brandon-bold big text-uppercase mb-3 text-center">
                Comunicação:
              </h3>
              <div
                class="apoio-wrapper d-flex justify-content-around flex-wrap"
              >
                <img src="@/assets/img/patrocinadores/comunicacao/sala.png" />
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </section>
    <section id="footer">
      <div id="footer-wrapper" class="container-fluid bg-gray-dark">
        <div class="container py-5">
          <b-row>
            <b-col sm="6" lg="4">
              <img
                id="logo-app"
                class="d-flex justify-content-end align-items-center"
                src="@/assets/img/2021/logo-app.png"
              />
            </b-col>
            <b-col
              sm="6"
              md="4"
              lg="6"
              class="d-flex justify-content-end align-items-center"
            >
              <p class="text-address text-white mb-0 font-brandon-regular">
                Av. João Erbolato, 364 - Jd. Chapadão - Cep. 13070-070 -
                Campinas - SP - Fone: (19) 3255-1081
              </p>
            </b-col>
            <b-col
              md="2"
              lg="2"
              class="
                d-flex
                justify-content-center
                align-items-center
                justify-content-md-end
              "
            >
              <a href="https://www.facebook.com/appcampinas" target="_blank"
                ><img
                  class="social-media-logo"
                  src="@/assets/img/2021/facebook-logo.png"
              /></a>
              <a href="https://www.instagram.com/appcampinas" target="_blank"
                ><img
                  class="social-media-logo"
                  src="@/assets/img/2021/instagram-logo.png"
              /></a>
            </b-col>
          </b-row>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  methods: {
    scrollToElement(refName) {
      document.getElementById(refName).scrollIntoView({
        behavior: "smooth",
      });
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scope>
@import "node_modules/bootstrap/scss/functions";
@import "node_modules/bootstrap/scss/variables";
@import "node_modules/bootstrap/scss/mixins/_breakpoints";

@include media-breakpoint-down(xs) {
  html {
    font-size: 12px;
  }
}

html {
  overflow-x: hidden;
}

@font-face {
  font-family: "Cleopatra";
  src: url("~@/assets/fonts/Cleopatra.ttf");
}

@font-face {
  font-family: "BrandonRegular";
  src: url("~@/assets/fonts/Brandon-Regular.otf");
}

@font-face {
  font-family: "BrandonBold";
  src: url("~@/assets/fonts/Brandon-Bold.otf");
}

.font-brandon-regular {
  font-family: BrandonRegular;
}

.font-brandon-bold {
  font-family: BrandonBold;
}

.font-cleopatra {
  font-family: Cleopatra;
}

#home {
  background-color: #f6f6f6;
}

/* MAIN BANNER */

#section-banner {
  position: relative;
  padding-top: 100px;
}

#logo-container {
  margin-bottom: 85px;
}

#midia-festival-logo {
  max-height: 60px;
  max-width: 80vw;
}

#melhores-ideias {
  margin: 18px 0;
  max-width: 60%;

  @include media-breakpoint-down(md) {
    max-width: 80%;
  }
}

#rect-grey-ground {
  width: 100%;
  background-color: #e4e4e4;
  height: 200px;
}

#img-banner {
  position: absolute;
  right: -200px;
  top: 40px;

  @include media-breakpoint-down(md) {
    top: 530px;
    right: -150px;
  }
  @include media-breakpoint-down(sm) {
    top: 530px;
    right: -210px;
  }
  @include media-breakpoint-down(xs) {
    width: 160vw;
    right: 0;
  }

  @media (min-width: 1400px) {
    right: 0;
  }
}

/* O FESTIVAL */
#section-festival {
  padding: 50px 0;
  position: relative;
  margin-bottom: 50px;
}

#img-o-festival {
  max-width: 100%;
  padding: 30px;
}

#text-festival {
  display: block;
  font-size: 1.8rem;
  font-family: "BrandonRegular";
  color: #9d9d9c;
  margin-top: 20px;
  margin: 20px 10px 0;

  @include media-breakpoint-up(xl) {
    position: absolute;
    right: 0;
    width: 48%;
    top: 34%;
    font-size: 1.7rem;
  }

  @media (min-width: 1400px) {
    position: absolute;
    right: 0;
    width: 50%;
    top: 34%;
    font-size: 1.8rem;
  }
}

/* REGULAMENTO */
#section-regulamento {
  z-index: 1;
  position: relative;
  background: black url("~@/assets/img/2022/regulamento-bg-full.png") no-repeat
    center center fixed;

  @include media-breakpoint-down(sm) {
    background-position-x: 60%;
  }

  background-size: cover;
  padding: 100px 0;
}

#img-regulamento-bg {
  width: 100%;
  position: absolute;
}

#regulamento-title-container {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  font-size: 9rem;
  letter-spacing: 0.12em;
  color: #9d9d9c;
  font-weight: normal;

  @include media-breakpoint-down(lg) {
    font-size: 7rem;
  }
  @include media-breakpoint-down(md) {
    font-size: 6rem;
  }
  @include media-breakpoint-down(sm) {
    font-size: 4rem;
  }
}

.regulamento-btn-container {
  display: flex;
  justify-content: center;
  width: 100%;

  @include media-breakpoint-down(md) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.regulamento-btn-container .btn-round:first-child {
  margin-left: 0;
}
.regulamento-btn-container .btn-round:last-child {
  margin-right: 0;
}

.btn-round.inscreva-se {
  font-family: BrandonBold;
  font-size: 1.5rem;
  margin-top: 60px;
}

.btn-round {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 2px solid;
  color: #9d9d9c;
  font-family: BrandonRegular;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.4rem;
  height: 70px;
  min-width: 278px;
  text-decoration: none;
  color: #9d9d9c;
  white-space: nowrap;
  margin-bottom: 25px;

  @include media-breakpoint-up(lg) {
    margin: 0 4%;
  }
}

.btn-round:hover {
  color: #fff;
  text-decoration: none;
  background: rgba(255, 255, 255, 0.15);
}

/* DATAS */
#section-datas {
  position: relative;
  height: 1200px;
}

#img-data-banner {
  top: -330px;
  position: absolute;
  z-index: 0;
  left: -760px;

  @include media-breakpoint-up(sm) {
    left: -690px;
  }
  @include media-breakpoint-up(md) {
    left: -660px;
  }
  @include media-breakpoint-up(lg) {
    left: -510px;
  }
  @media (min-width: 1400px) {
    left: -142px;
  }
  @media (min-width: 1700px) {
    left: -50px;
  }
}

#datas-container {
  position: relative;
}

#datas-position {
  position: absolute;
  top: 100px;
  right: 0;
  width: 57%;

  & h1 {
    margin-bottom: 1.5rem;
    & img {
      max-width: 50vw;
    }
  }

  @include media-breakpoint-down(lg) {
    font-size: 0.9rem;
    width: 63%;
  }
  @include media-breakpoint-down(md) {
    font-size: 0.8rem;
    width: 70%;
  }
  @include media-breakpoint-down(sm) {
    font-size: 0.7rem;
    width: 70%;
  }
  @media (min-width: 1400px) {
    width: 48%;
  }
}

.data-single-container {
  display: flex;
  align-items: center;
}

.txt-data-title {
  font-family: Cleopatra;
  font-size: 5em;
  color: #9d9d9c;
  margin-right: 15px;
  width: 200px;

  @include media-breakpoint-down(lg) {
    width: unset;
  }

  @include media-breakpoint-down(md) {
    width: unset;
  }
}

.txt-data-subtitle {
  font-family: BrandonRegular;
  text-transform: uppercase;
  font-size: 2em;
  color: #9d9d9c;
}

/* PATROCINADORES */
#section-patrocinadores {
  position: relative;
  z-index: 1;
}

/* FOOTER */

#logo-app {
  width: 300px;

  @include media-breakpoint-down(md) {
    width: 100%;
  }
}

/* REST */
.img-titulo {
  width: 300px;

  @include media-breakpoint-down(md) {
    width: 100%;
    max-width: 300px;
  }
}

.img-titulo-sm {
  width: 130px;
}

#txt-banner-subtitle {
  position: relative;
  font-family: BrandonRegular;
  text-transform: uppercase;
  color: #9d9d9c;
  line-height: 3rem;
  letter-spacing: 0.6rem;
  font-size: 1.6rem;
  margin-bottom: 80px;
  z-index: 1;

  @include media-breakpoint-down(lg) {
    margin-bottom: 120px;
  }

  @include media-breakpoint-down(md) {
    margin-bottom: 620px;
  }

  @include media-breakpoint-down(sm) {
    margin-bottom: 680px;
  }

  @include media-breakpoint-down(xs) {
    margin-bottom: calc(80vw);
  }
}

.img-titulo-md {
  width: 210px;

  @include media-breakpoint-down(md) {
    width: 100%;
    max-width: 210px;
  }
}

.mantenedores-ouro-wrapper img {
  align-self: center;
  max-height: 82px;
  max-width: 220px;
  margin: 10px 30px;
}

.mantenedores-prata-wrapper img {
  align-self: center;
  max-height: 70px;
  max-width: 170px;
  margin: 10px 20px;
}

.apoio-wrapper {
  & img {
    align-self: center;
    max-height: 70px;
    max-width: 130px;
    margin: 5px 20px;
  }
  &.primary-line img {
    max-width: 135px;
    max-height: 80px;
  }
}

.social-media-logo {
  height: 25px;
  margin-left: 15px;
}

@media (min-width: 1400px) {
  .container {
    max-width: 1340px;
  }
}

img {
  image-rendering: -moz-crisp-edges; /* Firefox        */
  image-rendering: -o-crisp-edges; /* Opera          */
  image-rendering: -webkit-optimize-contrast; /* Safari         */
  image-rendering: optimize-contrast; /* CSS3 Proposed  */
  -ms-interpolation-mode: nearest-neighbor; /* IE8+           */
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
</style>
